<div class="modal-header">
  <button mat-icon-button class="header-icon-btn ghost-btn" aria-hidden="true" tabindex="-1"
    style="visibility: hidden;">
    <mat-icon>movie</mat-icon>
  </button>

  <h2 class="modal-title">{{ 'Video allerta' }}</h2>

  <button mat-icon-button class="header-icon-btn close-btn" [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="video-dialog-content">
  @switch (state) {
  @case ('loading') {
  <div class="state-card">
    <ion-spinner name="crescent"></ion-spinner>
    <h3>Recupero video della allerta</h3>
    <p>Cercando la registrazione associata a questa allerta...</p>
  </div>
  }

  @case ('preparing') {
  <div class="state-card">
    <ion-spinner name="crescent"></ion-spinner>
    <h3>Preparazione video in corso</h3>
    <p>Registrazione Video trovata. In attesa che sia pronta per la riproduzione.</p>
  </div>
  }

  @case ('noVideo') {
  <div class="state-card muted">
    <mat-icon>videocam_off</mat-icon>
    <h3>Nessun video disponibile</h3>
    <p>Questa allerta non ha registrazioini associate da mostrare.</p>
  </div>
  }

  @case ('error') {
  <div class="state-card error">
    <mat-icon>error_outline</mat-icon>
    <h3>Impossibile caricare il video</h3>
    <p>{{ errorMessage }}</p>
    <ion-button mode="md" color="primary" (click)="loadVideo()">Riprova</ion-button>
  </div>
  }

  @case ('ready') {
  <div class="video-shell">
    <div class="video-wrapper">
      <video [src]="videoUrl || ''" controls autoplay playsinline preload="metadata"></video>
    </div>
  </div>
  }
  }
</mat-dialog-content>